import { createFileRoute } from '@tanstack/react-router'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Offcanvas } from '@/entities/offcanvas'
import { ProcessCard } from '@/entities/process/process-card'
import { useProcessRequestLaunches } from '@/shared/api/processes'
import { useRouteOffcanvas } from '@/shared/hooks/use-route-offcanvas'

export const Route = createFileRoute('/_auth/administration/monitoring/queue/$processId')({
  component: RouteComponent,
})

function RouteComponent() {
  const { t } = useTranslation()
  const { processId } = Route.useParams()
  const { isOpen, close } = useRouteOffcanvas()
  const { data } = useProcessRequestLaunches({
    processRequestId: processId,
    'pagination.page': 1,
    'pagination.pageSize': 1,
  })

  const latestLaunch = useMemo(() => {
    const launches = data?.launches || []
    if (!launches || launches.length === 0) return undefined
    const sorted = [...launches].sort(
      (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
    )
    return sorted[0]
  }, [data])

  return (
    <Offcanvas open={isOpen} onClose={close} title={t('Карточка заявки')}>
      <ProcessCard isLoading={false} isError={false} launch={latestLaunch} />
    </Offcanvas>
  )
}
